export default function RadioGroup({ value, options, onChange }) {
  return (
    <div className="flex items-center gap-4">
      {options.map((option) => (
        <div className="flex items-center h-[32px] cursor-pointer" key={option.value} onClick={() => onChange(option)}>
          <input
            checked={option.value === value.value}
            id={`radio-${option.value}`}
            type="radio"
            value={option.value}
            className="w-4 h-4 bg-gray-100 border-gray-300 focus:ring-blue-500 cursor-pointer"
            onChange={() => {}}
          />
          <label htmlFor={`radio-${option.value}`} className="ml-2 text-xs cursor-pointer">{option.label}</label>
        </div>
      ))}
    </div>
  )
}
